import React from "react";
import { format } from "date-fns";
import PropTypes from "prop-types";
import moment from "moment";

const TimelogSheet = React.forwardRef(
  ({ timelogData, employeeName,  companyDetails }, ref) => {
    const {
      attendanceDetails = [],
      workingSummary = [],
      timeLogSummary = [],
      waitingSummary = [],
      totalSummary = [],
      employeeProjectWorkingHours = [],
      leaveDetails = [],
    } = timelogData || {};

    const fromDate = attendanceDetails.at(-1)?.attendanceDate;
    const toDate = attendanceDetails[0]?.attendanceDate;

    const formatDate = (date) =>
      date ? format(new Date(date), "dd-MM-yyyy") : "";


    return (
      <div className="page-wrapper">
        <div className="content mb-3">
          <div
            className="pay-slip-box timelogSheet"
            id="timelogSheet"
            ref={ref}
          >
            <div className="card mb-0" style={{ padding: "20px" }}>
              <div className="card-body border-0 mb-3">
                {/* Header */}
                <div
                  className="timelogSheet-header d-flex"
                  style={{ justifyContent: "space-between" }}
                >
                  <div className="timelogSheet-title image-container">
                    <div className="timelogSheet-logo">
                      {companyDetails?.companyLogo && (
                        <img
                          // src={`${companyDetails.companyLogo}`}
                          src={`data:image/png;base64,${companyDetails?.companyLogo}`}
                          alt={companyDetails.companyName}
                        />
                      )}
                    </div>
                    <div className="timelogSheet-logo-title">
                      <h4>TIMESHEET | {companyDetails?.companyName}</h4>
                      <h4>Employee: {employeeName} ({attendanceDetails[0]?.uniqueID})</h4>
                    </div>
                  </div>
                  <div className="timelogSheet-title ">
                    <h6>
                      From: <span>{formatDate(fromDate)}</span>
                    </h6>
                    <h6>
                      To: <span>{formatDate(toDate)}</span>
                    </h6>
                  </div>
                </div>

                {/* Attendance Table */}
                <div className="table-responsive mb-3">
                  <table className="table table-bordered timelog-print">
                    <thead>
                      <tr>
                        <th>SlNo-1</th>
                        <th>Day</th>
                        <th>Date</th>
                        <th>In</th>
                        <th>Out</th>
                        <th>NH</th>
                        <th>OT1</th>
                        <th>OT2</th>
                        <th>TH</th>
                        <th>DW</th>
                        <th>EC</th>
                        <th>Late</th>
                        <th>WT</th>
                        <th>WTROT</th>
                        <th>Mode</th>
                        <th>Shift</th>
                        <th>Site</th>
                        <th>Project</th>
                        <th>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      {attendanceDetails.map((log, index) => (
                        <tr
                          key={index}
                          style={{ backgroundColor: "red" }}
                          className="bg-gray"
                        >
                          <td className={`${log.isHoliday ? "bg-gray" : ""}`}>
                            {index + 1}
                          </td>
                          <td className={`${log.isHoliday ? "bg-gray" : ""}`}>
                            {format(new Date(log.attendanceDate), "EEE")}
                          </td>
                          <td className={`${log.isHoliday ? "bg-gray" : ""}`}>
                            {formatDate(log.attendanceDate)}
                          </td>
                          <td className={`${log.isHoliday ? "bg-gray" : ""}`}>
                            {moment(log.inTime, ["HH:mm"]).format("HH:mm")}
                          </td>
                          <td className={`${log.isHoliday ? "bg-gray" : ""}`}>
                            {log.outTime === null
                              ? ""
                              : moment(log.outTime, ["HH:mm"]).format("HH:mm")}
                          </td>
                          <td className={`${log.isHoliday ? "bg-gray" : ""}`}>
                            {log.normalWorkingHours}
                          </td>
                          <td className={`${log.isHoliday ? "bg-gray" : ""}`}>
                            {log.oT1}
                          </td>
                          <td className={`${log.isHoliday ? "bg-gray" : ""}`}>
                            {log.oT2}
                          </td>
                          <td className={`${log.isHoliday ? "bg-gray" : ""}`}>
                            {log.totalWorkingHours}
                          </td>
                          <td className={`${log.isHoliday ? "bg-gray" : ""}`}>
                            {log.dayworking}
                          </td>

                          <td className={`${log.isHoliday ? "bg-gray" : ""}`}>
                            {log.extraCharge}
                          </td>
                          <td className={`${log.isHoliday ? "bg-gray" : ""}`}>
                            {log.late}
                          </td>
                          <td className={`${log.isHoliday ? "bg-gray" : ""}`}>
                            {moment(log.waitingTime, ["HH:mm"]).format("HH:mm")}
                          </td>
                          <td className={`${log.isHoliday ? "bg-gray" : ""}`}>
                            {moment(log.wtrot, ["HH:mm"]).format("HH:mm")}
                          </td>

                          <td className={`${log.isHoliday ? "bg-gray" : ""}`}>
                            {log.mode}
                          </td>
                          <td className={`${log.isHoliday ? "bg-gray" : ""}`}>
                            {log.shiftName}
                          </td>
                          <td
                            className={`${log.isHoliday ? "bg-gray" : ""}`}
                          ></td>
                          <td className={`${log.isHoliday ? "bg-gray" : ""}`}>
                            {log.projectName}
                          </td>
                          <td className={`${log.isHoliday ? "bg-gray" : ""}`}>
                            {log.remarks}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      {workingSummary[0].map((summary, index) => (
                        <tr key={index}>
                          <td colSpan="5">Total</td>
                          <td>{summary.normarWorkingHours}</td>
                          <td>{summary.oT1}</td>
                          <td>{summary.oT2}</td>
                          <td>{summary.totalWorkedHours}</td>
                          <td> </td>
                          <td>{summary.extraCharge}</td>
                          <td>{summary.totalLateHours}</td>
                          <td colSpan="6"></td>
                        </tr>
                      ))}
                    </tfoot>
                  </table>
                </div>

                {/* Summary Sections */}
                <div className="row timelog-print-summary">
                  {/* Days Summary */}
                  <div className="col-md-3">
                    <table className="mb-3">
                      <thead>
                        <tr>
                          <th>Days Summary</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      {timeLogSummary.map((s, idx) => (
                        <tbody key={idx}>
                          <tr>
                            <td>Total Calendar Working Days</td>
                            <td>{s.totalWorkingDaysinMonth}</td>
                          </tr>
                          <tr>
                            <td>Payable Working Days</td>
                            <td>{s.payableworkingDays}</td>
                          </tr>
                          <tr>
                            <td>Total Unpaid Days</td>
                            <td>{s.totalUnPaidLeaveDays}</td>
                          </tr>
                          <tr>
                            <td>Public Holiday</td>
                            <td>{s.publicHolidays}</td>
                          </tr>
                          <tr>
                            <td>Worked Days</td>
                            <td>{s.totalWorkedDays}</td>
                          </tr>
                        </tbody>
                      ))}
                    </table>

                    <table className="">
                      <thead>
                        <tr>
                          <th>Waiting Hours/OT Summary</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      {waitingSummary?.[0]?.map((s, idx) => (
                        <tbody key={idx}>
                          <tr>
                            <td>Total Normal Hours</td>
                            <td>{s.normarWorkingHours}</td>
                          </tr>
                          <tr>
                            <td>Total OT Hours</td>
                            <td>{s.oT1}</td>
                          </tr>
                          <tr>
                            <td>Total SOT Hours</td>
                            <td>{s.oT2}</td>
                          </tr>
                          <tr>
                            <td>ROT Hours</td>
                            <td>{s.restDayOTHours}</td>
                          </tr>

                          <tr>
                            <td>Total Hours</td>
                            <td>{s.totalHours}</td>
                          </tr>
                          <tr>
                            <td>Total Waiting Hours</td>
                            <td>{s.waitingTime}</td>
                          </tr>
                          <tr>
                            <td>Max OT</td>
                            <td>{s?.maxOT}</td>
                          </tr>
                        </tbody>
                      ))}
                    </table>
                  </div>

                  {/* Leave Summary (Static for now) */}
                  <div className="col-md-3">
                    <table className=" mb-3">
                      <thead>
                        <tr>
                          <th>Leave Summary</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Total Days Leave Applied</td>
                          <td>{timeLogSummary?.[0]?.totalAppliedLeave}</td>
                        </tr>
                        <tr>
                          <td>Total Paid Leaves</td>
                          <td>{timeLogSummary?.[0]?.totalPaidLeaveDays}</td>
                        </tr>
                        <tr>
                          <td>Total Un Paid Leave Applied</td>
                          <td>{timeLogSummary?.[0]?.totalUnPaidLeaveDays}</td>
                        </tr>
                        <tr>
                          <td>Total Days Absent</td>
                          <td>{timeLogSummary?.[0]?.totalAbsentDays}</td>
                        </tr>
                        <tr>
                          <td>Total Half Days</td>
                          <td>{timeLogSummary?.[0]?.totalHalfDays}</td>
                        </tr>
                        <tr>
                          <td>Total Days Paid Off</td>
                          <td>{timeLogSummary?.[0]?.totalPaidOffDays}</td>
                        </tr>
                        <tr>
                          <td>Total Days Off</td>
                          <td>{timeLogSummary?.[0]?.totalAbsentDays}</td>
                        </tr>
                        <tr>
                          <td>Total Rest Days</td>
                          <td>{timeLogSummary?.[0]?.totalRestDays}</td>
                        </tr>
                        <tr>
                          <td>Rest Working Days</td>
                          <td>{timeLogSummary?.[0]?.restWorkingDays}</td>
                        </tr>
                        <tr>
                          <td>Public Holiday working Days</td>
                          <td>
                            {timeLogSummary?.[0]?.publicHolidayWorkingDays}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="col-md-3">
                    <table className="">
                      <thead>
                        <tr>
                          <th>Hours/OT Summary</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      {workingSummary[0].map((s, idx) => (
                        <tbody key={idx}>
                          <tr>
                            <td>Total Normal Hours</td>
                            <td>{Number(s.normarWorkingHours).toFixed(2)}</td>
                          </tr>
                          <tr>
                            <td>Total OT Hours</td>
                            <td>{Number(s.oT1).toFixed(2)}</td>
                          </tr>
                          <tr>
                            <td>Total SOT Hours</td>
                            <td>{Number(s.oT2).toFixed(2)}</td>
                          </tr>
                          <tr>
                            <td>Total Hours</td>
                            <td>{Number(s.totalHours).toFixed(2)}</td>
                          </tr>
                          {/* <tr>
                            <td>Total OT Deductions</td>
                            <td></td>
                          </tr> */}
                        </tbody>
                      ))}
                    </table>
                    <table className="mb-3 mt-3">
                      <thead>
                        <tr>
                          <th>Total OT Summary</th>
                          <th>Total</th>
                        </tr>
                      </thead>

                      {totalSummary?.map((s, idx) => (
                        <tbody key={idx}>
                          <tr>
                            <td>Total OT1 Hours</td>
                            <td>{Number(s.oT1).toFixed(2)}</td>
                          </tr>
                          <tr>
                            <td>Total OT2 Hours</td>
                            <td>{Number(s.oT2).toFixed(2)}</td>
                          </tr>
                          <tr>
                            <td>Total Worked Hours</td>
                            <td>{Number(s.totalWorkedHours).toFixed(2)}</td>
                          </tr>
                        </tbody>
                      ))}
                    </table>
                  </div>

                  {/* Approval Status */}
                  <div className="col-md-3">
                    <table className="mb-3">
                      <thead>
                        <tr>
                          <th>Project</th>
                          <th>NH</th>
                          <th>OT1</th>
                          <th>OT2</th>
                        </tr>
                      </thead>
                      <tbody>
                        {employeeProjectWorkingHours?.map((w, _idx) => {
                          if (w) {
                            if (w) {
                              return (
                                <tr key={_idx}>
                                  <td>{w.projectName}</td>
                                  <td>{w.normalWorkingHours}</td>
                                  <td>{w.totalOT1}</td>
                                  <td>{w.totalOT2}</td>
                                </tr>
                              );
                            }
                          }
                        })}
                      </tbody>
                    </table>

                    <table className="mb-5">
                      <thead>
                        <tr>
                          <th colSpan={4}>Leave Days</th>
                        </tr>

                        <tr>
                          <th>Type</th>
                          <th>Applied</th>
                          <th>Paid</th>
                          <th>Un Paid</th>
                        </tr>
                      </thead>
                      <tbody>
                        {leaveDetails?.map((leave, index) => (
                          <tr key={index}>
                            <td>{leave.leaveName}</td>
                            <td>{leave.isApproved}</td>
                            <td>{leave.paidLeave}</td>
                            <td>{leave.unPaidLeave}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {attendanceDetails.every((entry) => entry.isApproved) ? (
                      <div
                        className="approved"
                        style={{
                          margin: "30px auto",
                          padding: "20px",
                          border: "5px dashed green",
                          width: "fit-content",
                          transform: "rotate(-15deg)",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "20px",
                            fontWeight: "600",
                            color: "#000000",
                          }}
                        >
                          Approved
                        </span>
                      </div>
                    ) : (
                      <div
                        className="un-approved"
                        style={{
                          margin: "30px auto",
                          padding: "20px",
                          border: "5px dashed red",
                          width: "fit-content",
                          transform: "rotate(-15deg)",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "20px",
                            fontWeight: "600",
                            color: "#000000",
                          }}
                        >
                          Not Approved
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                {/* Footer with Approval Details */}
                <hr />
                <div className="card-footer">
                  {/* justify-content-between d-flex */}
                  <div
                    className="text-center "
                    style={{ fontSize: "16px", fontWeight: "600" }}
                  >
                    <span>Approved by: {timeLogSummary?.[0]?.approvedBy}</span>
                    <span>On: {format(new Date(), "dd-MM-yyyy HH:mm:ss")}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

TimelogSheet.propTypes = {
  timelogData: PropTypes.object.isRequired,
  employeeName: PropTypes.string.isRequired,
  // uniqueId : PropTypes.string.isRequired,
  companyDetails: PropTypes.object.isRequired,
};

TimelogSheet.displayName = "TimelogSheet";

export default React.memo(TimelogSheet);
